import * as React from 'react';
import { Props } from 'react';
import { connect, Dispatch } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as queryString from 'query-string';

import { AppState } from '../../reducers';

import { setChannelUserIdAction, setUserPhoneAction, setChannelIdAction, setUserLangAction } from '../../actions/user';
import { registrationAction, resetSendCodeRegistrationAction } from '../../actions/Registration/registration';

import { IsSendCodeView } from '../RegistrationAuthorization/IsSendCodeView';
import i18next from 'i18next';

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface RegistrationIsSendCodeContainerProps extends Props<RegistrationIsSendCodeContainer> {
    lang: string;
    phone: string;
    channelUserId: string;
    channelId: string;
    bin: string;
    name: string;
    surname: string;
}

interface RegistrationIsSendCodeContainerDispatch extends Props<RegistrationIsSendCodeContainer> {
    onRegistration: (bin: string, phone: string, name: string, surname: string) => any;
    resetSendCodeRegistration: () => any;
    setLang: (lang: string) => any;
    setPhone: (phone: string) => any;
    setChannelUserId: (channelUserId: string) => any;
    setChannelId: (channelId: string) => any;
}

function mapProps(state: AppState, props: RegistrationIsSendCodeContainerProps): RegistrationIsSendCodeContainerProps {
    return {
        lang: state.userState.lang,
        phone: state.userState.phone,
        channelUserId: state.userState.channelUserId,
        channelId: state.userState.channelId,
        bin: state.registrationState.bin,
        name: state.registrationState.name,
        surname: state.registrationState.surname,
    };
}

function mapDispatch(dispatch: Dispatch<any>): RegistrationIsSendCodeContainerDispatch {
    return {
        setLang: (lang: string) => dispatch(setUserLangAction(lang)),
        setPhone: (phone: string) => dispatch(setUserPhoneAction(phone)),
        setChannelUserId: (channelUserId: string) => dispatch(setChannelUserIdAction(channelUserId)),
        setChannelId: (channelId: string) => dispatch(setChannelIdAction(channelId)),
        onRegistration: (bin: string, phone: string, name: string, surname: string) => dispatch(registrationAction(bin, phone, name, surname)),
        resetSendCodeRegistration: () => dispatch(resetSendCodeRegistrationAction()),
    };
}

class RegistrationIsSendCodeContainer extends React.Component<RegistrationIsSendCodeContainerProps & RegistrationIsSendCodeContainerDispatch & RouteProps> {
    async componentDidMount() {
        const { history, setPhone, setChannelUserId, setChannelId, setLang, lang } = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            const phone = params.phone;
            const channelUserId = params.user_id;
            const channel = params.channel_id;
            const language = params.lang;
            if (!lang) {
                setLang(language || 'ru');
            }
            if (language && language !== lang && i18next.languages.some(it => it === lang)) {
                setLang(language);
                await i18next.changeLanguage(language);
            }

            if (channel) {
                setChannelId(channel);
            }
            if (phone) {
                setPhone(phone);
            }
            if (channelUserId) {
                setChannelUserId(channelUserId);
            }
        }
    }

    render() {
        document.title = i18next.t('registration');
        const { phone, onRegistration, channelUserId, bin, name, surname, channelId, lang } = this.props;
        const { history, resetSendCodeRegistration } = this.props;
        return (
            <IsSendCodeView
                channelId={channelId}
                name={i18next.t('registration')}
                onSendCode={() => {
                    onRegistration(bin, phone, name, surname);
                    history.push(`/registration/sendCode?channel_id=${channelId}&phone=${phone}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`);
                }}
                onClose={() => {
                    resetSendCodeRegistration();
                    history.push(`/registration?channel_id=${channelId}&phone=${phone}&user_id=${encodeURIComponent(channelUserId)}&lang=${lang}`);
                }}
            />
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(RegistrationIsSendCodeContainer));



// WEBPACK FOOTER //
// ./src/components/Registration/RegistrationIsSendCodeContainer.tsx